import type { UserInquiriesResponse } from '@/types';

import GoBackButton from '../../../GoBackButton';

import { Box, Button, Image, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';

type ReferredUserProps = {
  goNext: () => void;
  goBack: () => void;
  parent: UserInquiriesResponse;
  hasReferralCode: boolean;
};

const ReferredUser: React.FC<ReferredUserProps> = ({
  goNext,
  goBack,
  parent,
  hasReferralCode,
}) => {
  const { t } = useTranslation('pages.signUp.form.referredUser');

  return (
    <Stack flex={1} w="100%" h="100%" align="flex-end" gap={4}>
      <Stack w="100%" flexDir="column" align="center" justify="center" gap={4}>
        <Text
          fontSize={{ base: 'md', lg: 'xl' }}
          w="full"
          fontWeight="medium"
          textAlign="center"
        >
          {t('title')}
        </Text>
        <Text w="100%" textAlign="center" color="gray.700">
          {t('description')}
        </Text>
        <Stack
          flexDir={{ base: 'column', md: 'row' }}
          align="center"
          justify="space-between"
          bgColor="gray.250"
          borderRadius={8}
          mt={{ base: '50px', md: '80px' }}
          gap={4}
          w="100%"
          padding="16px"
        >
          <Stack
            w="100%"
            flexDir="row"
            align="center"
            justify={{ base: 'center', md: 'flex-start' }}
            gap={4}
          >
            {/* <Box
              position="relative"
              w="72px"
              h="72px"
              sx={{
                '& img': { objectFit: 'cover', borderRadius: 'round' },
              }}
            >
              <Image src={parent.avatar} alt="parentAvatar" fill s/>
            </Box> */}
            <Box
              borderRadius={50}
              position="relative"
              width="72px"
              height="72px"
              sx={{
                '& img': { objectFit: 'cover' },
              }}
            >
              <Image
                src={parent.avatar}
                alt="parentAvatar"
                width={72}
                height={72}
              />
            </Box>
            <Stack width={'100'}>
              <Text w="100%" textAlign="right" fontSize="small">
                {`${parent.first_name} ${parent.last_name}`}
              </Text>
              <Text
                w="100%"
                textAlign="right"
                fontSize="smaller"
                color="gray.700"
              >
                {`${t('referralCode')} : ${parent.id}`}
              </Text>
            </Stack>
          </Stack>
          <Button
            w={{ base: 'full', md: 'max-content' }}
            onClick={() => goNext()}
          >
            {t('select')}
          </Button>
        </Stack>
      </Stack>
      {!hasReferralCode && (
        <Stack w="100%" mt="auto" align="center" justify="center">
          <GoBackButton goBack={goBack} />
        </Stack>
      )}
    </Stack>
  );
};
export default ReferredUser;
